import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "revico-community-talk-post--reviewer-attribute" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.communityTalkStore.getPostableReviewerAttributes(), (reviewerAttribute, index) => {
      return (_openBlock(), _createElementBlock("ul", {
        class: "revico-community-talk-post--reviewer-attribute-item",
        key: index
      }, [
        _createElementVNode("li", null, [
          _createVNode($setup["CustomLabel"], {
            text: reviewerAttribute.displayName,
            disabled: $props.disabled
          }, null, 8 /* PROPS */, ["text", "disabled"]),
          _createVNode($setup["PostReviewerAttributeItem"], {
            reviewerAttribute: reviewerAttribute,
            "reviewer-attribute-preset": $setup.communityTalkStore.getCommunityTalkUserReviewerAttributes().filter((e) => e.ReviewerAttributeId === reviewerAttribute.reviewerAttributeId)[0],
            "unique-key": $setup.uniqueKey,
            onClickReviewerAttributettributeChoice: $setup.checkReviewerAttrChoice
          }, null, 8 /* PROPS */, ["reviewerAttribute", "reviewer-attribute-preset", "unique-key"])
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}